/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuIcon } from '@neutron/react';

export const BlueSpanText = styled.span`
  color: var(--primary-60) !important;
`;

export const CardTitle = styled.h6`
  font-size: 1rem !important;
  font-weight: 600;
`;

export const GreyCardTitle = styled.h6`
  color: rgb(104, 104, 104) !important;
  font-size: 0.9rem !important;
  font-weight: 500;
`;

export const OptionsContainer = styled.div`
  flex: 0 0 26%;
`;

export const SingleContainer = styled.div``;

export const MultiContainer = styled(SingleContainer)`
  flex-direction: column;
`;

export const NextQuestionIcon = styled(NeuIcon)`
  font-size: 24px;
`;

export const PastAnswerContent = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  flex-basis: 20%;
  padding-top: 0;
`;

export const PastQuestionTitle = styled.h6`
  font-weight: 500;
  flex-basis: 80%;
  font-size: 1rem !important;
`;

export const GreyPastQuestionTitle = styled(PastQuestionTitle)`
  color: rgb(104, 104, 104) !important;
  font-size: 0.9rem !important;
`;

export const PastAnswerText = styled.div`
  color: var(--primary-60) !important;
  font-weight: 600;
  font-size: 1rem;
`;

export const ChipWrapper = styled.span`
  margin-bottom: 0.25rem !important;
`;
